import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Form, Input, Modal, notification, Row, Space, Typography } from 'antd';
import { CloseOutlined, DeleteOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import FormLabel from '../../../components/FormLabel';
import NormalFormLabel from '../../../components/NormalFormLabel';
import CustomSelect from '../../../components/CustomSelect';
import { LIST_ACTIONS, LIST_STATUS_ROLE } from '../../../constants/appSelect';
import { useMutation } from '@tanstack/react-query';
import { updatePermissionRequest } from '../../../services/permissionRequest';

const SuaTinhNang = ({
  open,
  setOpen,
  dataPermissionGroupOption,
  refetchDataPermissions,
  permissionInfo,
  setPermissionInfo,
}) => {
  const [form] = Form.useForm();
  const handleCancel = () => {
    setOpen(false);
    setPermissionInfo(null);
  };

  useEffect(() => {
    if (permissionInfo) {
      form.setFieldsValue({ ...permissionInfo, actions: permissionInfo.actions?.map((i) => ({ ...i, check: true })) });
    }
  }, [permissionInfo, form]);

  // handle submit form
  const { mutate: mutateUpdatePermission, isPending: isLoadingUpdatePermission } = useMutation({
    mutationFn: updatePermissionRequest,
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Chỉnh sửa tính năng thành công!',
        });
        refetchDataPermissions();
        form.resetFields();
        setPermissionInfo(null);
        setOpen(false);
      } else {
        notification.error({
          message: data?.errors || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({
        message: error.data?.showMessage  || 'Có lỗi xảy ra vui lòng thử lại sau!',
      });
    },
  });

  const handleSubmitForm = (data) => {
    const check = data.actions?.some((item) => (!item.api || !item.action_id) && item.check);
    if (check) {
      notification.warning({ message: 'Vui lòng nhập đủ thông tin cho action được chọn!' });
      return;
    }
    data.actions = data.actions
      .filter((item) => item.check)
      .map((item) => ({
        id: item?.id,
        name: LIST_ACTIONS.find((action) => action?.value === item?.action_id)?.label,
        api: item?.api,
        action_id: item?.action_id,
      }));
    mutateUpdatePermission({ ...data, id: permissionInfo.id });
  };

  return (
    <Modal title="Sửa nhóm quyền" open={open} onCancel={handleCancel} footer={null} width={840}>
      <Form layout="vertical" form={form} onFinish={handleSubmitForm} requiredMark={false}>
        <Form.Item
          label={<FormLabel text="Tên tính năng" />}
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên tính năng' }]}
        >
          <Input allowClear placeholder="Nhập tên tính năng" />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Nhóm tính năng" />}
          name="permission_group_id"
          rules={[{ required: true, message: 'Vui lòng chọn nhóm tính năng' }]}
        >
          <CustomSelect placeholder="Chọn nhóm tính năng" options={dataPermissionGroupOption} />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Key menu" />}
          name="key_menu"
          rules={[{ required: true, message: 'Vui lòng nhập key menu' }]}
        >
          <Input allowClear placeholder="Nhập key menu..." />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="URL view" />} name="url" initialValue="">
          <Input allowClear placeholder="Nhập url view..." />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="API" />}
          name="api"
          rules={[{ required: true, message: 'Vui lòng nhập api' }]}
        >
          <Input allowClear placeholder="Nhập api..." />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Trạng thái" />}
          name="status"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
          initialValue={0}
        >
          <CustomSelect placeholder="Chọn trạng thái..." options={LIST_STATUS_ROLE} />
        </Form.Item>
        <Typography.Text className={'mb-4 block text-lg'}>Danh sách actions</Typography.Text>
        <Form.List name="actions">
          {(fields, { add, remove }) => (
            <Row gutter={[8, 8]}>
              <Col xs={24}>
                <Space direction="vertical" style={{ width: '100%' }}>
                  {fields.map(({ key, name, ...restField }) => (
                    <Row gutter={[8, 8]} className="rounded-md px-4 py-2">
                      <Col xs={1}>
                        <Form.Item {...restField} name={[name, 'id']} hidden></Form.Item>
                        <Form.Item {...restField} name={[name, 'check']} valuePropName="checked">
                          <Checkbox />
                        </Form.Item>
                      </Col>
                      <Col xs={8}>
                        <Form.Item {...restField} name={[name, 'action_id']}>
                          <CustomSelect placeholder="Chọn action..." options={LIST_ACTIONS} />
                        </Form.Item>
                      </Col>
                      <Col xs={14}>
                        <Form.Item {...restField} name={[name, 'api']}>
                          <Input allowClear placeholder="Nhập api..." />
                        </Form.Item>
                      </Col>
                      <Col xs={1}>
                        <Button onClick={() => remove(name)} type="text" danger>
                          <DeleteOutlined className="text-xl" />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Space>
              </Col>
              <Col xs={24} className="flex flex-col justify-center items-center">
                <Button onClick={() => add()}>
                  <PlusOutlined />
                  Thêm action
                </Button>
              </Col>
            </Row>
          )}
        </Form.List>

        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>
            <CloseOutlined /> Hủy bỏ
          </Button>
          <Button loading={isLoadingUpdatePermission} type="primary" htmlType="submit">
            <SaveOutlined /> Lưu lại
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default SuaTinhNang;
